import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-type-auto",
  "use": "foquz-icon-type-auto-usage",
  "viewBox": "0 0 19 17",
  "content": "<symbol viewBox=\"0 0 19 17\" fill=\"none\" id=\"foquz-icon-type-auto\"><rect x=\"1.333\" y=\"6\" width=\"16\" height=\"10\" rx=\"3\" stroke=\"currentColor\" stroke-width=\"2\" /><circle cx=\"5.833\" cy=\"9.5\" r=\"1.5\" fill=\"currentColor\" /><circle cx=\"12.834\" cy=\"9.5\" r=\"1.5\" fill=\"currentColor\" /><path stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" d=\"M7.333 13h4.001m-2-7V2\" /><circle cx=\"9.334\" cy=\"2\" r=\"2\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol